import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {

  private readonly keyBase64: string = '71FAE290A9254983A8CB8C161175AFF0537E4B8843274E75B69C1C5CDE7C5D60'; // SAME as used in .NET
  private secretKey = '71FAE290A9254983A8CB8C161175AFF0537E4B8843274E75B69C1C5CDE7C5D60';
  private ReqResp_key = CryptoJS.enc.Utf8.parse('97F755F40AB04E5B8E4C4B79396643D8'); // Must be 16 bytes
  private ReqResp_iv = CryptoJS.enc.Utf8.parse('97F755F40AB04E5B');  // Must be 16 bytes
  
  constructor() {}

  decrypt(cipherText: string, ivBase64: string): string {
    const key = CryptoJS.enc.Base64.parse(this.keyBase64);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);

    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  encrypt(plainText: string): { cipherText: string; iv: string } {
    const key = CryptoJS.enc.Base64.parse(this.keyBase64);
    const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes = 128-bit IV

    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return {
      cipherText: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      iv: iv.toString(CryptoJS.enc.Base64)
    };
  }
  encryptData(value: any): any {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    return CryptoJS.AES.encrypt(stringValue, this.secretKey).toString();
  }

  decryptData(encrypted: any): any {
    const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  decryptAES(encrypted: string): string {
      const decrypted = CryptoJS.AES.decrypt(encrypted, this.ReqResp_key, {
        iv: this.ReqResp_iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
//  encryptAES(data: string): string {
//       const encrypted = CryptoJS.AES.encrypt(data, this.ReqResp_key, {
//         iv: this.ReqResp_iv,
//         mode: CryptoJS.mode.CBC,
//         padding: CryptoJS.pad.Pkcs7
//       });
//       return encrypted.toString();
//     }
encryptAES(data: string): string {
  const key = CryptoJS.enc.Utf8.parse('97F755F40AB04E5B8E4C4B79396643D8');
  const iv = CryptoJS.enc.Utf8.parse('97F755F40AB04E5B');

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();
}

}
